// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3593cabb] .el-dialog__body {\n  display: flex;\n  margin-top: -20px;\n}\n[data-v-3593cabb] .el-dialog__footer {\n  top: 20px;\n  position: relative;\n}\n.map[data-v-3593cabb] {\n  flex-grow: 1;\n  height: calc(100vh - 85px);\n  margin-bottom: -100px;\n}", ""]);
// Exports
module.exports = exports;
